/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

 import Api from '@/services/api';
 import AuthService from '@/services/auth';
 import Store from '@/store/index';

 export default {
  resetStore() {
    // reset store to empty
    Store.dispatch('estates/setEstates', {
      estates: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['estates/estates'].length < 1) {
      try {
        const response = await Api().get('/estates/list_all');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('estates/setEstates', {
              estates: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          await AuthService.logSupportDebug('estate.ts - listAll - 45 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    vendorId: number,
    name: string,
    shortCode: string,
    address: string,
    contactNumber: string,
    defaultCodeLimit: number,
    
  }) {
    return Api().post('/estate/create', params);
  },

  update(params: {
    id: number,
    vendorId: number,
    name: string,
    shortCode: string,
    address: string,
    contactNumber: string,
    defaultCodeLimit: number,
    suspended: boolean,
  }) {
    return Api().post('/estate/update', params);
  },

};
